<template>
    <form v-if="myrender" role="form">
        <div class="container-fluid" style="overflow-y: scroll; height: 500px;">
            <div class="row">

                <!--___________________________DATI ANAGRAFICI CLIENTE___________________________-->

                <div class="col-md-6" >
                    <label class="text-left">{{datiAnagraficiClienteLbl}}</label>
                    <div style="display: inline-block; border-top: 1px solid lightgray; content: ''; top: 20px; right: 10em; vertical-align: top; bottom: 0; width: 100%;"> </div>
                    <div class="form-group">
                        <div class="col-sm-5">
                            <span class="align-middle">{{ragioneSocialeLbl}}</span>
                        </div>
                        <div class="col-sm-7">
                            <input disabled v-model="ragioneSocialeValue" type="text" id="ragioneSocialeId" class="form-control form-control-cust" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-sm-5">
                            <span class="align-middle">{{codiceFiscaleLbl}}</span>
                        </div>
                        <div class="col-sm-7">
                            <input disabled type="text" v-model="codiceFiscValue" id="codiceFiscValueId" class="form-control form-control-cust" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-sm-5">
                            <span class="align-middle">{{partitaIvaLbl}}</span>
                        </div>
                        <div class="col-sm-7">
                            <input disabled type="number" v-model.number="partitaIvaValue" id="partitaIvaId"  class="form-control form-control-cust" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-sm-5">
                            <span class="align-middle">{{nomeTitolareLbl}}</span>
                        </div>
                        <div class="col-sm-7">
                            <input disabled type="text" v-model="nomeTitolareValue" id="nomeTitolareId" class="form-control form-control-cust" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-sm-5">
                            <span class="align-middle">{{indirizzoDittaLbl}}</span>
                        </div>
                        <div class="col-sm-7">
                            <input disabled type="text" v-model="indirizzoDittaValue" id="indirizzoDittaId" class="form-control form-control-cust" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-sm-5">
                            <span class="align-middle">{{capLbl}}</span>
                        </div>
                        <div class="col-sm-7">
                            <input disabled type="text" v-model="capValue" id="capId" class="form-control form-control-cust" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-sm-5">
                            <span class="align-middle">{{localitaLbl}}</span>
                        </div>
                        <div class="col-sm-7">
                            <input disabled type="text" v-model="localitaValue" id="localitaId" class="form-control form-control-cust" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-sm-5">
                            <span class="align-middle">{{provinciaLbl}}</span>
                        </div>
                        <div class="col-sm-7">
                            <input disabled type="text" v-model="provinciaValue" id="provinciaId" class="form-control form-control-cust" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-sm-5">
                            <span class="align-middle">{{nazioneLbl}}</span>
                        </div>
                        <div class="col-sm-7">
                            <input disabled type="text" v-model="nazioneValue"  id="nazioneId" class="form-control form-control-cust" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-sm-5">
                            <span class="align-middle">{{telefonoLbl}}</span>
                        </div>
                        <div class="col-sm-7">
                            <input disabled type="text" v-model="telefonoValue"  id="televonoId" class="form-control form-control-cust" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-sm-5">
                            <span class="align-middle">{{faxLbl}}</span>
                        </div>
                        <div class="col-sm-7">
                            <input disabled type="text" v-model="faxValue"  id="faxId" class="form-control form-control-cust" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-sm-5">
                            <span class="align-middle">{{mailLbl}}</span>
                        </div>
                        <div class="col-sm-7">
                            <input disabled type="text" id="mailId" v-model="mailValue"  class="form-control form-control-cust" />
                        </div>
                    </div>
                </div>
                <!--************************************************************************************************************************************-->
                <div class="col-md-6">
                    
                    <!--___________________________CONSEGNA___________________________-->
                    
                    <div>
                        <label class="text-left">{{consegnaLbl}}</label>
                        <div style="display: inline-block; border-top: 1px solid lightgray; content: ''; top: 20px; right: 10em; vertical-align: top; bottom: 0; width: 100%;"> </div>
                        <div v-if="showReqDeliveryDate" class="form-group">
                            <div class="col-sm-5">
                                <span class="align-middle">{{dataConsegnaRichiestaLbl}}</span>
                            </div>
                            <div class="col-sm-7">
                                <datepicker :open-date="openDate" :disabledDates="disabledDates" id="dataConsegnaRichiestaId" v-model="dataConsegnaRichiestaValue" style="padding: 0px; color: black; height: 26px; width: 150px" :full-month-name="true"
                                :clear-button="true" :placeholder="$Jed.firstUpperTranslate('select')+' '+$Jed.translate('date')" format="dd / MM / yyyy" :language="datePickLang"></datepicker>
                            </div>
                        </div>
                        <div v-if="!hidePortType" class="form-group">
                            <div class="col-sm-5">
                                <span class="align-middle">{{tipoPortoLbl}}</span>
                            </div>
                            <div class="col-sm-7">
                                <v-select label="type"  style="width: 100%" :options="portTypesList" @input="onPortTypeinput($event)" v-model="portTypeValue" :placeholder="$Jed.firstUpperTranslate('select')+' '+$Jed.translate('port type')">
                                </v-select>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-sm-5">
                                <span class="align-middle">{{indirizzoSpedizioneLbl}}</span>
                            </div>
                            <div class="col-sm-7">
                                <div class="row">
                                    <cfg cid="shopCart2.chooseAddress" tag='div' class="col-sm-9" @click="!disableAddressChoice ? showTip() : null">
                                        <v-select label="type" style="width: 100%" :options="addressesList" v-model="addressValue" :tagStyle="{'width': '85%','white-space': 'nowrap', 'overflow': 'hidden', 'text-overflow': 'ellipsis'}"
                                            @input="onShipAddressInput()" :disabled="disableAddressChoice" :placeholder="$Jed.firstUpperTranslate('select')+' '+$Jed.translate('address')">
                                        </v-select>
                                    </cfg>
                                    <cfg cid="shopCart2.addAddress" tag='div' v-if="enableAddAddress" style="display: inline;">
                                        <a style="cursor: pointer;" @click.prevent="addAddressClick">
                                            <i :class="$root.icons.plus" style="font-size: 1.8em;" aria-hidden="true"></i>
                                        </a>
                                    </cfg>
                                    <cfg cid="shopCart2.editAddress" tag='div' v-if="enableAddAddress && addressChosen && (addressValue && !addressValue.obj.pid)" style="display: inline;">
                                        <a style="cursor: pointer;" @click.prevent="modifyAddressClick">
                                            <i :class="$root.icons.edit" style="font-size: 1.8em;" aria-hidden="true"></i>
                                        </a>
                                    </cfg>
                                    <cfg cid="shopCart2.deleteAddress" tag='div' v-if="enableAddAddress && addressChosen && (addressValue && !addressValue.obj.pid)" style="display: inline;">
                                        <a style="cursor: pointer;" @click.prevent="delAddressClick">
                                            <i :class="$root.icons.close" style="font-size: 1.8em;" aria-hidden="true"></i>
                                        </a>
                                    </cfg>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-sm">
                                <span class="align-middle">&nbsp;</span>
                            </div>
                        </div>
                        <div class="form-group" style="height: 70px;">
                            <div class="col-sm-5 text-left">
                                <label v-if="addressChosen" class="text-left">{{riepilogoIndirizzoLbl}}</label>
                            </div>
                            <div class="col-sm-7">
                                <div>{{nominativoSped}}</div>
                                <div>{{indirizzoSped}}</div>
                                <div>{{capSped}} {{localitaSped}} {{sigPro}}</div>
                                <div>{{nazioneSped}}</div>
                            </div>                                        
                        </div>
                        <div class="form-group">
                            <div class="col-sm">
                                <span class="align-middle">&nbsp;</span>
                            </div>
                        </div>
                    </div>
                    
                    <!--___________________________SPEDIZIONE___________________________-->

                    <cfg cid="shopCart2.shippingTypeArea" tag="div">
                        <label class="text-left" style="vertical-align: bottom;">{{spedizioneLbl}}</label>
                        <div style="display: inline-block; border-top: 1px solid lightgray; content: ''; top: 20px; right: 10em; vertical-align: top; bottom: 0; width: 100%;"> </div>
                        <div class="form-group">
                            <div class="col-sm-5">
                                <span class="align-middle">{{tipoSpedizioneLbl}}</span>
                            </div>
                            <div class="col-sm-7">
                                <v-select label="type" style="width: 100%" :options="shippingTypesList" :disabled="disableShippingChoice" v-model="shippingTypeValue" :placeholder="$Jed.firstUpperTranslate('select')+' '+$Jed.translate('Tipo Spedizione')">
                                </v-select>                                            
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-sm-5">
                                <span class="align-middle">{{accorpaSpedizioneLbl}}</span>
                            </div>
                            
                            <div class="col-sm-7">
                                <input type="checkbox" v-model="accorpaSpedizioneValue" :disabled="disableShippingChoice" style="display: inline-block; position: relative; width:20px; height: 20px" />
                            </div>
                        </div>
                    </cfg>
                </div>
                <!--______________________________________________________________________________________________________________________________-->                               
            </div>
            <div class="row">
                <div class="col-md">&nbsp;</div>
            </div>
            <!--___________________________PULSANTI___________________________-->
            <div class="row">
                <div class="col-md-7">
                    <div class="controls col-sm-3">
                        <button @click.prevent="previousClick" class="btn btn-primary-default" style="width: 130px">{{indietroBtnLbl}}</button>
                    </div>
                    <div class="controls col-sm-3">
                        <button @click.prevent="forwardClick" class="btn btn-primary-default" style="width: 130px">{{avantiBtnLbl}}</button>
                    </div>
                    <cfg cid="shopCart.nuovoOrdineBtn" tag='div'>
                        <div class="controls col-sm-3">
                            <button @click.prevent="cleanShopCartClick"  class="btn btn-danger" style="width: 140px">{{$Jed.firstUpperTranslate('new order')}}</button>
                        </div>
                    </cfg>
                </div>
                <div class="col-md-5"></div>
            </div>
            <div class="row">
                <div class="col-md">&nbsp;</div>
            </div>
        </div>
    </form>
    <div v-else></div>
</template>

<script>

import Datepicker from "vuejs-datepicker";
import {it, en, es, fr, de, ru} from 'vuejs-datepicker/dist/locale'
import DynTableWrapper from "../../dynamic/DynTableWrapper.vue";
import vSelect from "../../dynamic/vueSelectWrapper/components/Select.vue"
import table_resize_mixin from "../../../mixins/table_resize_mixin.js";
import { eventBus } from "../../../eventbus";
import {Checkbox} from 'vue-checkbox-radio';
import PopoverAlert from "../../dynamic/popoverWrapper/Popover.vue";
import Cfg from "../../dynamic/ConfigurableComponent.vue";

export default {
    mixins: [],
    components: {
        DynTableWrapper,
        Datepicker,
        vSelect,
        Checkbox,
        PopoverAlert,
        Cfg
    },
    data: function () {
        var vm = this;
        return {
            datiAnagraficiClienteLbl: vm.$Jed.firstUpperTranslate('client personal data'),
            consegnaLbl: vm.$Jed.firstUpperTranslate('delivery'),
            spedizioneLbl: vm.$Jed.firstUpperTranslate('shipping'),
            dataConsegnaRichiestaLbl: vm.$Jed.firstUpperTranslate('requested delivery date'),
            codiceFiscaleLbl: vm.$Jed.firstUpperTranslate('fiscal code'),
            tipoPortoLbl: vm.$Jed.firstUpperTranslate('port type'),
            ragioneSocialeLbl: vm.$Jed.firstUpperTranslate('business name'),
            partitaIvaLbl: vm.$Jed.firstUpperTranslate('vat number'),
            indirizzoSpedizioneLbl: vm.$Jed.firstUpperTranslate('address'),
            nomeTitolareLbl: vm.$Jed.firstUpperTranslate('Nome Titolare'),
            indirizzoDittaLbl: vm.$Jed.firstUpperTranslate('address'),
            capLbl: vm.$Jed.firstUpperTranslate('CAP'),
            localitaLbl: vm.$Jed.firstUpperTranslate('Localita'),
            provinciaLbl: vm.$Jed.firstUpperTranslate('province'),
            zonaClienteLbl: vm.$Jed.firstUpperTranslate('Zona Cliente'),
            nazioneLbl: vm.$Jed.firstUpperTranslate('country'),
            telefonoLbl: vm.$Jed.firstUpperTranslate('phone'),
            faxLbl: vm.$Jed.firstUpperTranslate('fax'),
            mailLbl: vm.$Jed.firstUpperTranslate('email'),
            accorpaSpedizioneLbl: vm.$Jed.firstUpperTranslate('Accorpa Spedizione'),
            tipoSpedizioneLbl: vm.$Jed.firstUpperTranslate('Tipo Spedizione'),
            riepilogoIndirizzoLbl: vm.$Jed.firstUpperTranslate('Riepilogo Indirizzo'),
            indietroBtnLbl: vm.$Jed.firstUpperTranslate('back'),
            avantiBtnLbl: vm.$Jed.firstUpperTranslate('continue'),

            ragioneSocialeValue: vm.$root.shopCartData.anagraficaCliente.ragioneSociale,
            codiceFiscValue:  vm.$root.shopCartData.anagraficaCliente.codiceFiscale,
            partitaIvaValue: vm.$root.shopCartData.anagraficaCliente.partitaIva,
            nomeTitolareValue: vm.$root.shopCartData.anagraficaCliente.nomeTitolare,
            indirizzoDittaValue: vm.$root.shopCartData.anagraficaCliente.indirizzo,
            capValue: vm.$root.shopCartData.anagraficaCliente.cap,
            localitaValue: vm.$root.shopCartData.anagraficaCliente.localita,
            provinciaValue: vm.$root.shopCartData.anagraficaCliente.provincia,
            //Non usato --- zonaClienteValue: vm.$root.shopCartData.anagraficaCliente.regione,
            nazioneValue: vm.$root.shopCartData.anagraficaCliente.nazione,
            telefonoValue: vm.$root.shopCartData.anagraficaCliente.telefono,
            faxValue: vm.$root.shopCartData.anagraficaCliente.fax,
            mailValue: vm.$root.shopCartData.anagraficaCliente.mail,

            dataConsegnaRichiestaValue: null,
            portTypeValue: null, 
            portTypesList: [],
            addressValue: null,
            addressesList: [],
            nominativoSped: "",
            indirizzoSped: "",
            localitaSped: "",
            capSped: "", 
            sigPro: "",
            nazioneSped: "",

            shippingTypeValue: null, 
            shippingTypesList: [],
            accorpaSpedizioneValue: false,

            disableAddressChoice: true,
            enableAddAddress: false,
            disableShippingChoice: false,

            address_tip: vm.$Jed.firstUpperTranslate('select port type'),
            disabledDates: {
                to: new Date(Date.now())
            },
            datePickLang: null,
            openDate: null,
            addressChosen: false,
            shippingChosen: false,
            newAddressAdded: false,
            hidePortType: false,
            showReqDeliveryDate: true,

            reg_addresses: null, 
            reg_portTypes: null,
            reg_shippingTypes: null,
            reg_nations: null,
            reg_clients: null,
            reg_storehouses: null,
            reg_provinces: null,
            reg_zones: null,
            reg_orders: null,
            myrender: true
        }
    },
    created: function() {
        console.log('created')
        this.loadCollections();
        
        //imposto la lingua per il datepicker
        if(this.$root.lang.lang == 'it'){
            this.datePickLang = it;
        }else if(this.$root.lang.lang == 'en'){
            this.datePickLang = en;
        }else if(this.$root.lang.lang == 'fr'){
            this.datePickLang = fr;
        }else if(this.$root.lang.lang == 'de'){
            this.datePickLang = de;
        }else if(this.$root.lang.lang == 'es'){
            this.datePickLang = es;
        }else if(this.$root.lang.lang == 'ru'){
            this.datePickLang = ru;
        }

        //imposto la data visualizzata all'apertura del datepicker (la data di richiesta consegna deve essere > oggi)
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        this.openDate = tomorrow;

        var vm = this;
        eventBus.$on("resetRiepilogo",()=>{
            vm.addressValue = null
            vm.addressChosen = false;
        })

        eventBus.$on("gotChanges",()=>{
            var reg_orders = vm.$root.dbRegistry.getCollection('orders'),
                reg_addresses = vm.$root.dbRegistry.getCollection('addresses'),
                idC = vm.$root.token.idCliente,
                order = reg_orders.find({'$loki': vm.$root.shopCartData.$loki}), //uso $loki perchè questo serve per aggiornare le schermate quando ho inserito un prodotto in carrello e ancora ci sono gli id provvisori (negativi) per ordine e righeordine
                address = reg_addresses.find({'cid': idC});
            if(order && order[0]){
                vm.$root.shopCartData.id = order[0].id; //imposto il nuovo id per la struttura che rappresenta il carrello (cioè ShopCartData) così posso usare questa proprietà per recuperare il record dall'idb quando serve
            }

            //TODO: ricontrollare come vengono aggiornati gli indirizzi, in particolare alla modifica indirizzo e all'eliminazione
            if(address){
                var updated = address.find(function(element) {
                    return element.$loki == Math.abs(vm.$root.shopCartData.consegna.idIndirizzo)
                });
                if(updated){
                    vm.$root.shopCartData.consegna.idIndirizzo = updated.id
                }
            }
        
            if(!vm.newAddressAdded){ //se ho appena inserito un nuovo indirizzo, non ricarico tutti i menù dropdown
                vm.updateData()
                vm.loadCollections()
                //console.log('CHIAMO fillAddressesDropdown riga 402')
                vm.fillAddressesDropdown()
                vm.newAddressAdded = false
            }
        })
    },
    mounted: function() {
        var vm = this;
    },
    beforeMount: function(){
        if(this.$Behaviors.hideDeliveryCartStep)this.myrender = false
    },
    beforeDestroy: function(){
        this.getData()
    },
    methods: {
        updateData( ) {
            var vm = this;

            this.ragioneSocialeValue = this.$root.shopCartData.anagraficaCliente.ragioneSociale;
            this.codiceFiscValue = this.$root.shopCartData.anagraficaCliente.codiceFiscale;
            this.partitaIvaValue = this.$root.shopCartData.anagraficaCliente.partitaIva;

            this.nomeTitolareValue = this.$root.shopCartData.anagraficaCliente.nomeTitolare;
            this.indirizzoDittaValue = this.$root.shopCartData.anagraficaCliente.indirizzo;
            this.capValue = this.$root.shopCartData.anagraficaCliente.cap;
            this.localitaValue = this.$root.shopCartData.anagraficaCliente.localita;
            this.provinciaValue = this.$root.shopCartData.anagraficaCliente.provincia;
            //Non usato --- this.zonaClienteValue = this.$root.shopCartData.anagraficaCliente.regione;
            this.nazioneValue = this.$root.shopCartData.anagraficaCliente.nazione;
            this.telefonoValue = this.$root.shopCartData.anagraficaCliente.telefono;
            this.faxValue = this.$root.shopCartData.anagraficaCliente.fax;
            this.mailValue = this.$root.shopCartData.anagraficaCliente.mail;

            /**
                imposta porto, indirizzo, tipoSpedizione nella schermata in base ai valori presenti nella struttura che rappresenta il carrello
            */
            this.dataConsegnaRichiestaValue = this.$root.shopCartData.consegna.consegnaRichiesta
            
            if(vm.portTypesList && vm.$root.shopCartData.consegna.tipoPorto) {
                vm.portTypeValue = vm.portTypesList.find(function(element) {
                    return element.obj.id === vm.$root.shopCartData.consegna.tipoPorto;
                });
            }else{
                vm.portTypeValue = null
            }

            if(vm.addressesList && vm.$root.shopCartData.consegna.idIndirizzo) {
                vm.addressValue = vm.addressesList.find(function(element) {
                    return element.obj.id === vm.$root.shopCartData.consegna.idIndirizzo;
                });
                vm.nominativoSped = this.$root.shopCartData.consegna.nominativo ? this.$root.shopCartData.consegna.nominativo : "";
                vm.indirizzoSped = this.$root.shopCartData.consegna.indirizzo;
                vm.localitaSped = this.$root.shopCartData.consegna.localita;
                vm.capSped = this.$root.shopCartData.consegna.cap;
                vm.sigPro = this.$root.shopCartData.consegna.sigPro;
                vm.nazioneSped = this.$root.shopCartData.consegna.nazione;
                vm.addressChosen = true
            }

            if(this.portTypeValue && this.portTypeValue.obj && this.portTypeValue.obj.fre != 'Fabbrica'){
                if(vm.shippingTypesList && vm.$root.shopCartData.spedizione.tipoSpedizione){
                    vm.shippingTypeValue = vm.shippingTypesList.find(function(element) {
                        return element.obj.id === vm.$root.shopCartData.spedizione.tipoSpedizione
                    });
                }
                if(this.$root.shopCartData.spedizione.accorpaSpedizione == this.$Jed.firstUpperTranslate('yes') || vm.$root.shopCartData.spedizione.accorpaSpedizione == true){
                    this.accorpaSpedizioneValue = true
                }else if(this.$root.shopCartData.spedizione.accorpaSpedizione == this.$Jed.firstUpperTranslate('no') || vm.$root.shopCartData.spedizione.accorpaSpedizione == false){
                    this.accorpaSpedizioneValue = false
                }                
            }
        },
        async loadCollections() {
            var vm = this;
            try {                
                vm.reg_addresses = vm.$root.dbRegistry.getCollection('addresses');
                vm.reg_orders = vm.$root.dbRegistry.getCollection('orders')
                vm.reg_clients = await vm.$root.fetchRegistryData("client", "GetClients", "collection")
                vm.reg_zones = await vm.$root.fetchRegistryData("zones", "GetZones", "collection")
                
                if(this.$root.preferences.useOffline){
                    if(!vm.$root.dbServRegistry) {
                        console.log("ShopCart2 - loadCollections - dbServRegistry not loaded!");
                        return;
                    }
                    vm.reg_portTypes = vm.$root.dbServRegistry.getCollection('ports');
                    vm.reg_shippingTypes = vm.$root.dbServRegistry.getCollection('shippingTypes');
                    vm.reg_nations = vm.$root.dbServRegistry.getCollection('nations');
                    vm.reg_storehouses = vm.$root.dbServRegistry.getCollection('storehouses');
                    vm.reg_provinces = vm.$root.dbServRegistry.getCollection('provinces');
                } else {
                    vm.reg_portTypes = vm.$root.dbRegistry.getCollection('ports');
                    vm.reg_shippingTypes = vm.$root.dbRegistry.getCollection('shippingTypes');
                    vm.reg_nations = vm.$root.dbRegistry.getCollection('nations');
                    vm.reg_storehouses = await this.$root.fetchRegistryData("storehouses", "GetStorehouses", "collection")
                    vm.reg_provinces = await this.$root.fetchRegistryData("provinces", "GetProvinces", "collection")
                }

                var current_lang = vm.$root.token.siglaLingua;

                //1) popolo la tendina dei porti
                var ports = vm.reg_portTypes.data
                vm.portTypesList = [];
                ports.forEach(function(item) {      
                    var description = item.des[current_lang];
                    if(!description) 
                        description = item.des[vm.$root.token.defaultLang]; 
                    if(vm.$root.token.categoriaCliente == 'Cliente distributore'){
                        if(item.fre != 'Fabbrica'){
                            vm.portTypesList.push({
                                value: item.$loki,
                                type: description,
                                obj: item
                            });
                        }
                    }else{
                        vm.portTypesList.push({
                            value: item.$loki,
                            type: description,
                            obj: item
                        });
                    }
                });

                if(vm.portTypesList && vm.$root.shopCartData.consegna.tipoPorto) {
                    var tipoPortoVal = vm.portTypesList.find(function(element) {
                        return element.obj.id === vm.$root.shopCartData.consegna.tipoPorto;
                    });

                    if(!vm.portTypeValue){
                        vm.portTypeValue = tipoPortoVal;
                    }
                }
                //1.1) porto di default gestito da behaviour
                if(this.$Behaviors.presetDefaultPort && !vm.portTypeValue){
                    var defPortType = vm.portTypesList.find(function(el) {
                        return el.obj.def == -1
                    });
                    if(defPortType){
                        vm.portTypeValue = defPortType
                        //dopo aver inserito quello di default posso nascondere il campo
                        this.hidePortType = this.$Components["shopCart2.portType"].hidden;

                        //impostazione automatica indirizzo di consegna
                        if(this.$Behaviors.presetFirstAddressOfDefaultPort){
                            //se porto di default è franco magazzino, imposto l'indirizzo del primo magazzino
                            //se porto di default è franco fabbrica, imposto l'indirizzo del produttore
                            //altrimenti imposto il primo indirizzo di consegna del cliente
                            var address, addressCompleteString;
                            if(vm.portTypeValue.obj.fre=='Magazzino'){
                                var cli_addresses = vm.reg_addresses.find({cid: vm.$root.token.idCliente}), 
                                    mags = [];
                                for(var c in cli_addresses){
                                    var id_mag = cli_addresses[c].sti
                                    if(id_mag && id_mag!=""){
                                        var alreadyInArray = mags.includes(id_mag)
                                        if(!alreadyInArray){
                                            mags.push(id_mag); 
                                        }
                                    }
                                }
                                address = vm.reg_storehouses.find({id: mags[0]})[0] //il primo magazzino
                                if(address){
                                    addressCompleteString = (address.nam ? address.nam : '') + ' - ' + (address.add ? address.add : '') + ',' +  (address.cap ? address.cap : '') + ',' +  (address.loc ? address.loc : '');
                                }else{
                                    eventBus.$emit("alert", {type: "warning", message: vm.$Jed.firstUpperTranslate('storehouse address is missing')});
                                }
                            }else if(vm.portTypeValue.obj.fre=='Fabbrica'){
                                address = vm.reg_addresses.find({faa: true, dea: true})[0] //indirizzo di consegna del produttore 
                                if(address){
                                    addressCompleteString = (address.add ? address.add : '') + ',' +  (address.cap ? address.cap : '') + ',' +  (address.loc ? address.loc : '') + (address.type ? (',' +  address.type) : '');
                                }else{
                                    eventBus.$emit("alert", {type: "warning", message: vm.$Jed.firstUpperTranslate('delivery address of producer is missing')});
                                }
                            }else{
                                address = vm.reg_addresses.find({dea: true, cid: vm.$root.token.idCliente})[0] //primo indirizzo di consegna del cliente
                                if(address){
                                    addressCompleteString = (address.add ? address.add : '') + ',' +  (address.cap ? address.cap : '') + ',' +  (address.loc ? address.loc : '') + (address.type ? (',' +  address.type) : '');
                                }else{
                                    eventBus.$emit('alert', { type: "warning", message: vm.$Jed.firstUpperTranslate('delivery address of client is missing')})
                                }
                            }
                            this.addressValue = {
                                value: address.$loki,
                                type: addressCompleteString,
                                obj: address
                            }
                            this.$root.shopCartData.consegna.idIndirizzo = address.id
                        }else{
                            //console.log('CHIAMO fillAddressesDropdown riga 592')
                            this.fillAddressesDropdown();
                        }
                    }
                }
                //2) data consegna/ritiro 
                this.dataConsegnaRichiestaValue = this.$root.shopCartData.consegna.consegnaRichiesta
                //gestione behaviour abilita “data consegna richiesta” quando il porto è franco fabbrica
                if(this.$Behaviors.enableDeliveryDateOnlyForEXWPort){ 
                    if(vm.portTypeValue && vm.portTypeValue.obj.fre=='Fabbrica'){
                        this.showReqDeliveryDate = true
                    }else{
                        this.showReqDeliveryDate = false
                    }
                }else{
                    this.showReqDeliveryDate = true
                }

                //3) tipo spedizione di default gestito da behaviour
                if(this.$Behaviors.presetFirstShippingTypeOfClientZone){
                    try{
                        var pid = this.reg_addresses.find({id: this.$root.shopCartData.anagraficaCliente.idIndirizzo})[0].pid
                        if(pid){
                            var zona = this.reg_provinces.find({id: pid})[0]
                            var firstShippingTypeOfClientZone = this.reg_shippingTypes.find({'zid': zona.zid})[0];
                            this.shippingTypeValue =  {
                                value: firstShippingTypeOfClientZone.$loki,
                                type: firstShippingTypeOfClientZone.des[this.$root.token.defaultLang], 
                                obj: firstShippingTypeOfClientZone
                            }
                            this.$root.shopCartData.spedizione.tipoSpedizione = firstShippingTypeOfClientZone.id
                            this.$root.shopCartData.spedizione.tipoSpedizioneDes = firstShippingTypeOfClientZone.des[this.$root.token.defaultLang];
                        }
                    }catch(e){console.log(e)}
                }
                if(this.$Behaviors.hideDeliveryCartStep)this.onPortTypeinput();
            } catch (error) {
                console.log(error);
            }
        }, 
        onPortTypeinput(event){ //scelgo/cambio porto, devo popolare la tendina indirizzi
            this.$root.shopCartData.consegna.tipoPorto = this.portTypeValue ? this.portTypeValue.obj.id : '';
            eventBus.$emit('resetRiepilogo');
            this.disableAddressChoice = false;
            var vm = this,
                idC = vm.$root.token.idCliente;         

            //svuoto sia la scelta dell'indirizzo nella tendina, sia il riepilogo indirizzo
            vm.addressValue = null
            vm.nominativoSped =  null
            vm.indirizzoSped =  null
            vm.localitaSped = null 
            vm.capSped = null
            vm.sigPro = null
            vm.nazioneSped = null
            vm.shippingChosen = false;
            vm.disableShippingChoice = false;

            //data consegna richiesta
            if(this.$Behaviors.enableDeliveryDateOnlyForEXWPort){ //abilita “data consegna richiesta” quando il porto è franco fabbrica
                if(vm.portTypeValue && vm.portTypeValue.obj.fre=='Fabbrica'){
                    this.showReqDeliveryDate = true
                }else{
                    this.showReqDeliveryDate = false
                }
            }else{
                this.showReqDeliveryDate = true
            }

            if(vm.$root.token.categoriaCliente == 'Cliente distributore'){
                if(vm.portTypeValue && vm.portTypeValue.obj && vm.portTypeValue.obj.fre && vm.portTypeValue.obj.fre == 'Magazzino'){
                    vm.addressValue = null;
                    vm.enableAddAddress = false;
                    vm.accorpaSpedizioneValue = null;
                    vm.shippingChosen = true;
                    vm.disableShippingChoice = true;
                    vm.shippingTypeValue = null

                    if(vm.reg_clients){
                        var distributore = vm.reg_clients.find({id: idC})[0].pci //padre del cliente distributore
                        if(distributore != idC){
                            var dist_addresses = vm.reg_addresses.find({cid: distributore, dea: true}) //indirizzi di consegna del distributore 
                            vm.addressesList = [];
                            for(var d in dist_addresses){
                                var address = dist_addresses[d];
                                var addressCompleteString = (address.add ? address.add : '') + ',' +  (address.cap ? address.cap : '') + ',' +  (address.loc ? address.loc : '') + (address.type ? (',' +  address.type) : '');
                                vm.addressesList.push({
                                    value: address.$loki,
                                    type: addressCompleteString,
                                    obj: address
                                });
                            }
                            //pre-seleziono un indirizzo se c'era già
                            if(vm.addressesList && vm.$root.shopCartData.consegna.idIndirizzo) {
                                var prevAddress = vm.addressesList.find(function(element) {
                                    return element.obj.id === vm.$root.shopCartData.consegna.idIndirizzo
                                });

                                if(!vm.addressValue && prevAddress){
                                    this.addressRecap(prevAddress);
                                }
                            }else{
                                vm.addressChosen = false;
                            }
                        }
                    }                
                }else{
                    vm.addressValue = null;
                    vm.addressesList = [];
                    vm.enableAddAddress = true;
                    //console.log('CHIAMO fillAddressesDropdown riga 702')
                    this.fillAddressesDropdown();
                }
            }else{
                if(vm.portTypeValue && vm.portTypeValue.obj && vm.portTypeValue.obj.fre && vm.portTypeValue.obj.fre == 'Fabbrica'){
                    vm.disableAddressChoice = true;
                    vm.enableAddAddress = false;
                    //con i porti franchi (fabbrica e magazzino) la spedizione è disabilitata e non viene fatto il controllo al passaggio allo step successivo
                    vm.disableShippingChoice = true;
                    vm.accorpaSpedizioneValue = null
                    vm.shippingTypeValue = null
                    vm.shippingChosen = true;

                    var address = vm.reg_addresses.find({faa: true, dea: true})[0] //indirizzo di consegna del produttore 
                    if(address){
                        var addressCompleteString = (address.add ? address.add : '') + ',' +  (address.cap ? address.cap : '') + ',' +  (address.loc ? address.loc : '') + (address.type ? (',' +  address.type) : '');
                        var addressObj = {
                            value: address.$loki,
                            type: addressCompleteString,
                            obj: address
                        }
                        vm.addressesList.push(addressObj);    
                        if(!vm.addressValue){
                            this.addressRecap(addressObj);
                        }
                    }else{
                        eventBus.$emit("alert", {type: "warning", message: this.$Jed.firstUpperTranslate('delivery address of producer is missing')});
                    }
                }else if(vm.portTypeValue && vm.portTypeValue.obj && vm.portTypeValue.obj.fre && vm.portTypeValue.obj.fre == 'Magazzino'){
                    //con i porti franchi (fabbrica e magazzino) la spedizione è disabilitata e non viene fatto il controllo al passaggio allo step successivo
                    vm.disableShippingChoice = true;
                    vm.accorpaSpedizioneValue = null
                    vm.shippingTypeValue = null
                    vm.shippingChosen = true;

                    var cli_addresses = vm.reg_addresses.find({cid: idC}), //indirizzi del cliente
                        mags = [];
                    for(var c in cli_addresses){
                        var id_mag = cli_addresses[c].sti
                        if(id_mag && id_mag!=""){
                            var alreadyInArray = mags.includes(id_mag)
                            if(!alreadyInArray){
                                mags.push(id_mag); //id dei magazzini associati agli indirizzi del cliente
                            }
                        }
                    }
                    vm.addressesList = [];

                    for(var m in mags){
                        var magazzino = vm.reg_storehouses.find({id: mags[m]})
                        try{
                            magazzino = magazzino[0]
                            var addressCompleteString = (magazzino.nam ? magazzino.nam : '') + ' - ' + (magazzino.add ? magazzino.add : '') + ',' +  (magazzino.cap ? magazzino.cap : '') + ',' +  (magazzino.loc ? magazzino.loc : '');
                            vm.addressesList.push({
                                value: magazzino.$loki,
                                type: addressCompleteString,
                                obj: magazzino
                            });
                        }catch(e){console.log(e)}
                    }

                    //pre-seleziono un indirizzo se c'era già
                    if(vm.addressesList && vm.$root.shopCartData.consegna.idIndirizzo) {
                        var prevAddress = vm.addressesList.find(function(element) {
                            return element.obj.id === vm.$root.shopCartData.consegna.idIndirizzo
                        });

                        if(!vm.addressValue && prevAddress){
                            this.addressRecap(prevAddress);
                        }
                    }
                }else{
                    vm.addressValue = null;
                    vm.addressesList = [];
                    vm.enableAddAddress = true;
                    //console.log('CHIAMO fillAddressesDropdown riga 777')
                    this.fillAddressesDropdown();
                }
            }
        },
        fillAddressesDropdown(source){
            var vm = this;
            //1) popolo la tendina degli indirizzi
            /* console.log('SOURCE:', source)
            console.log('SHOPCARTDATA.CONSEGNA:', vm.$root.shopCartData.consegna)
            console.log('REG_ADDRESSES:', vm.reg_addresses) */
            if(vm.reg_addresses){ 
                var idC = vm.$root.token.idCliente;
                var filter = {cid: idC};
                if(vm.$root.shopCartData.consegna.idIndirizzo){
                    filter = {$or: [filter, {id: vm.$root.shopCartData.consegna.idIndirizzo}]};
                }

                var results = vm.reg_addresses.find(filter); //indirizzi del cliente o indirizzo preesistente
                
                if(results && results.length > 0){
                    vm.addressesList = [];
                    for(var idx in results ) {
                        var address = results[idx];
                        //console.log(address.pid, address.sip, address.pro)
                        var addressCompleteString = (address.add ? address.add : '') + ',' +  (address.cap ? address.cap : '') + ',' +  (address.loc ? address.loc : '') + (address.pro ? (',' +  address.pro) : '');
                        vm.addressesList.push({
                            value: address.$loki,
                            type: addressCompleteString,
                            obj: address
                        });
                    }

                    //2) pre-seleziono un indirizzo se c'era già
                    //console.log('INDIRIZZO PRECEDENTE: ', vm.$root.shopCartData.consegna)
                    if(vm.addressesList && vm.$root.shopCartData.consegna.idIndirizzo) {
                        var prevAddress = vm.addressesList.find(function(element) {
                            return element.obj.id === vm.$root.shopCartData.consegna.idIndirizzo
                        });

                        if(!vm.addressValue && prevAddress){ 
                            this.addressRecap(prevAddress);
                        }
                    }

                    //3) se ho appena inserito un nuovo indirizzo, lo pre-seleziono
                    if(source){
                        vm.newAddressAdded = true;
                        var newAddress = vm.addressesList.find(function(element) {
                            return element.obj.id === source.id
                        });

                        if(newAddress){ 
                            this.addressRecap(newAddress);
                        }
                    }
                }else{
                    vm.addressesList = [];
                    console.log('collection addresses vuota');
                }
            } 
        },
        addressRecap(address){
            //console.log('ADDRESS RECAP: ', address)
            this.addressValue = address;
            this.nominativoSped = address.obj.con ? address.obj.con : '';
            this.indirizzoSped = address.obj.add ? address.obj.add : '';
            this.localitaSped = address.obj.loc ? address.obj.loc : '';
            this.capSped = address.obj.cap ? address.obj.cap : '';
            if(address.obj.pid)this.sigPro = address.obj.sip ? address.obj.sip : '';
            this.nazioneSped = address.obj.nat ? address.obj.nat : '';
            this.addressChosen = true
            if(this.$Behaviors.hideDeliveryCartStep)this.onShipAddressInput()
        },
        onShipAddressInput() {
            var vm = this; 
            vm.addressChosen = true;
            vm.nominativoSped =  null
            vm.indirizzoSped =  null
            vm.localitaSped = null 
            vm.capSped = null
            vm.sigPro = null
            vm.nazioneSped = null
            vm.shippingTypesList = [];
            vm.shippingTypeValue = null

            var address = vm.addressValue ? vm.addressValue.obj : null;
            console.log('ON SHIP ADDRESS INPUT: ', address)
            console.log('SHOPCARTDATA.SPEDIZIONE:', vm.$root.shopCartData.spedizione)
            try{
                if(address){
                    this.$root.shopCartData.consegna.idIndirizzo = address.id;
                    this.$root.shopCartData.consegna.nominativo = address.con; 
                    this.$root.shopCartData.consegna.indirizzo = address.add;
                    this.$root.shopCartData.consegna.localita = address.loc;
                    this.$root.shopCartData.consegna.cap = address.cap;
                    this.$root.shopCartData.consegna.sigPro = this.$Behaviors.allowFreeProvince ? '' : (address.sip ? address.sip : address.pro);
                    this.$root.shopCartData.consegna.provincia = address.pro;
                    this.$root.shopCartData.consegna.regione = address.reg;
                    this.$root.shopCartData.consegna.nazione = address.nat;
                    
                    this.nominativoSped = this.$root.shopCartData.consegna.nominativo;
                    this.indirizzoSped = this.$root.shopCartData.consegna.indirizzo;
                    this.localitaSped = this.$root.shopCartData.consegna.localita;
                    this.capSped = this.$root.shopCartData.consegna.cap;
                    this.sigPro = this.$root.shopCartData.consegna.sigPro;
                    this.nazioneSped = this.$root.shopCartData.consegna.nazione;

                    var  current_lang = vm.$root.token.siglaLingua;

                    //1) ricavo i tipi spedizione che hanno zona uguale a quella dell'indirizzo selezionato               
                    var zona = null;
                    if(address.pid){
                        if(vm.reg_provinces){
                            zona = vm.reg_provinces.find({id: address.pid})
                        }
                    }
                    if(zona){
                        if(zona && zona.length > 0){
                            zona = zona[0]
                            if(vm.reg_shippingTypes) {
                                var shippingTypes = vm.reg_shippingTypes.find({'zid': zona.zid});
                                if( shippingTypes && shippingTypes.length > 0 ) {
                                    vm.shippingTypesList = [];
                                    for(var idx in shippingTypes) {
                                        var shippingType = shippingTypes[idx];
                                    
                                        var description = shippingType.des[current_lang] ? shippingType.des[current_lang] : shippingType.des[vm.$root.token.defaultLang];

                                        vm.shippingTypesList.push({
                                            value: shippingType.$loki,
                                            type: description, 
                                            obj: shippingType
                                        });
                                    }
                                    //2) pre-seleziono un tipo spedizione se c'era già
                                    if(vm.shippingTypesList && vm.$root.shopCartData.spedizione.tipoSpedizione) {
                                        var spedtyp = vm.shippingTypesList.find(function(element) {
                                            return element.obj.id === vm.$root.shopCartData.spedizione.tipoSpedizione
                                        });

                                        if(!vm.shippingTypeValue){
                                            vm.shippingTypeValue = spedtyp;
                                        }
                                    }
                                    if(!vm.accorpaSpedizioneValue && vm.$root.shopCartData.spedizione.accorpaSpedizione){
                                        if(vm.$root.shopCartData.spedizione.accorpaSpedizione == vm.$Jed.firstUpperTranslate('yes') || vm.$root.shopCartData.spedizione.accorpaSpedizione == true){
                                            vm.accorpaSpedizioneValue = true
                                        }else if(vm.$root.shopCartData.spedizione.accorpaSpedizione == vm.$Jed.firstUpperTranslate('no') || vm.$root.shopCartData.spedizione.accorpaSpedizione == false){
                                            vm.accorpaSpedizioneValue = false
                                        } 
                                    }
                                }
                            }
                        }
                    }else{ //l'indirizzo è stato inserito dall'utente e non ha la proprietà pid
                        var siglaNaz;
                        console.log('SHOPCARTDATA.SPEDIZIONEEEEEEE:', vm.$root.shopCartData.spedizione)
                        if(address.nat){
                                var filter;
                                if(vm.$root.token.categoriaCliente == 'Cliente distributore'){
                                    filter = {'$and': [{cid : vm.$root.token.idClienteDistributore},{nam: address.nat},{fan : true}]}
                                }else if(vm.$Behaviors.useFirstZoneOfNationForShipping){
                                    filter = {nam: address.nat}
                                }else{
                                    filter = {'$and': [{nam: address.nat},{fan : true}]}
                                }

                                var zona = vm.reg_zones.find(filter)
                                
                                console.log('EEE LA ZONA???:', zona)
                                console.log(vm.reg_zones)
                                console.log(filter)

                                if(zona && zona.length > 0){
                                    //prendo la prima zona della nazione
                                    zona = zona[0]
                                    if(vm.reg_shippingTypes) {
                                        var shippingTypes = vm.reg_shippingTypes.find({'zid': zona.id});
                                        if(shippingTypes && shippingTypes.length > 0) {
                                            vm.shippingTypesList = [];
                                            for(var idx in shippingTypes ) {
                                                var shippingType = shippingTypes[idx];
                                            
                                                var description = shippingType.des[current_lang] ? shippingType.des[current_lang] : shippingType.des[vm.$root.token.defaultLang];

                                                vm.shippingTypesList.push({
                                                    value: shippingType.$loki,
                                                    type: description,
                                                    obj: shippingType
                                                });
                                            }

                                            //2) pre-seleziono un tipo spedizione se c'era già
                                            if(vm.shippingTypesList && vm.$root.shopCartData.spedizione.tipoSpedizione) {
                                                var spedtyp = vm.shippingTypesList.find(function(element) {
                                                    return element.obj.id === vm.$root.shopCartData.spedizione.tipoSpedizione
                                                });

                                                if(!vm.shippingTypeValue){
                                                    vm.shippingTypeValue = spedtyp;
                                                }
                                            }
                                            if(!vm.accorpaSpedizioneValue && vm.$root.shopCartData.spedizione.accorpaSpedizione){
                                                if(vm.$root.shopCartData.spedizione.accorpaSpedizione == vm.$Jed.firstUpperTranslate('yes') || vm.$root.shopCartData.spedizione.accorpaSpedizione == true){
                                                    vm.accorpaSpedizioneValue = true
                                                }else if(vm.$root.shopCartData.spedizione.accorpaSpedizione == vm.$Jed.firstUpperTranslate('no') || vm.$root.shopCartData.spedizione.accorpaSpedizione == false){
                                                    vm.accorpaSpedizioneValue = false
                                                } 
                                            }
                                        }
                                    }
                                }
                        } else {
                            eventBus.$emit("alert", {type: "warning", message: this.$Jed.firstUpperTranslate('invalid delivery address: check nation is not null')});
                        }
                    }
                }else{
                    console.log('nessun indirizzo')
                    console.log(vm.addressValue)
                    vm.$root.shopCartData.consegna.consegnaRichiesta = "";
                    vm.$root.shopCartData.consegna.idIndirizzo = null;
                    vm.$root.shopCartData.consegna.nominativo = ""; 
                    vm.$root.shopCartData.consegna.indirizzo = ""; 
                    vm.$root.shopCartData.consegna.localita = ""; 
                    vm.$root.shopCartData.consegna.cap = "";
                    vm.$root.shopCartData.consegna.sigPro = "";
                    vm.$root.shopCartData.consegna.nazione = "";  
                    vm.$root.shopCartData.consegna.provincia = "";
                    vm.$root.shopCartData.consegna.regione = "";  

                    vm.$root.shopCartData.spedizione = {}
                }
            }catch(e){
                console.log(e)
            }
            if(this.$Behaviors.hideDeliveryCartStep)this.$emit('changeComponentEvent', 3, this.getData());
        },
        showTip(){
            if(this.disableAddressChoice){
                eventBus.$emit("alert", {type: "warning", message: this.address_tip});
            }
        },
        previousClick () {
            this.$emit('changeComponentEvent',1, this.getData())  ;
        },
        forwardClick () {
            var data = {};

            if(!this.portTypeValue){
                eventBus.$emit("alert", {type: "warning", message: this.$Jed.firstUpperTranslate('select port type')});
                return;
            }

            if(!this.addressValue){
                eventBus.$emit("alert", {type: "warning", message: this.$Jed.firstUpperTranslate('select address')});
                return;
            }
            
            if(!this.$Components["shopCart2.shippingTypeArea"].hidden && !this.shippingTypeValue && !this.shippingChosen){
                eventBus.$emit("alert", {type: "warning", message: this.$Jed.firstUpperTranslate('select shipping type')});
                return;
            }

            this.$emit('changeComponentEvent', 3, this.getData());
        },
        addAddressClick () {
            this.$emit('onOpenAddAddressEvent');
        },
        modifyAddressClick () {
            var vm = this;
            this.$emit('onOpenModifyAddressEvent', vm.addressValue);
        },
        delAddressClick () {
            var vm = this
            var ok = function(){
                    vm.$emit('onDeleteAddressEvent', vm.addressValue.obj);
                    vm.addressValue = null
                    vm.nominativoSped =  null
                    vm.indirizzoSped =  null
                    vm.localitaSped = null 
                    vm.capSped = null
                    vm.sigPro = null
                    vm.nazioneSped = null
                    this.close();
                },
                no = function(){
                    this.close();
                },
                e = {
                    message: this.$Jed.firstUpperTranslate('selected address') + ': '+ vm.addressValue.type + '<br>' + this.$Jed.firstUpperTranslate('Do you want to delete it?'), 
                    ok: ok,
                    no: no
                }
            eventBus.$emit("confirm", e) 
        },
        cleanShopCartClick () {
             this.$emit('onCleanShopCartEvent','')  ;      
        },
        changeStep: function(val) {  
            if (val != 2)          
                this.$emit('changeComponentEvent',val, this.getData())  ;  
        },     
        getData() {
            this.$root.shopCartData.consegna.consegnaRichiesta = this.dataConsegnaRichiestaValue ? this.dataConsegnaRichiestaValue : null;

            //ho selezionato il tipo spedizione
            if(this.shippingTypeValue &&  this.shippingTypeValue.obj){ 
                this.$root.shopCartData.spedizione.tipoSpedizione =  this.shippingTypeValue.obj.id;
                this.$root.shopCartData.spedizione.tipoSpedizioneDes = this.shippingTypeValue.obj.des[this.$root.token.defaultLang];
            }else if(this.$Behaviors.presetFirstShippingTypeOfClientZone && !this.shippingChosen){
                //non ho selezionato il tipo spedizione (è nascosto) E
                //ho un behaviour che dice di preimpostare il primo della zona del cliente E
                //il porto non è franco
                try{
                    var pid = this.reg_addresses.find({id: this.$root.shopCartData.anagraficaCliente.idIndirizzo})[0].pid
                    if(pid){
                        var zona = this.reg_provinces.find({id: pid})[0]
                        var firstShippingTypeOfClientZone = this.reg_shippingTypes.find({'zid': zona.zid})[0];
                        this.$root.shopCartData.spedizione.tipoSpedizione = firstShippingTypeOfClientZone.id
                        this.$root.shopCartData.spedizione.tipoSpedizioneDes = firstShippingTypeOfClientZone.des[this.$root.token.defaultLang];
                    }
                }catch(e){console.log(e)}
            }

            if(this.portTypeValue && this.portTypeValue.obj && this.portTypeValue.obj.fre != 'Fabbrica'){
                this.$root.shopCartData.spedizione.accorpaSpedizione = this.accorpaSpedizioneValue ? this.$Jed.firstUpperTranslate('yes') : this.$Jed.firstUpperTranslate('no');
            }

            if(this.portTypeValue &&  this.portTypeValue.obj){
                this.$root.shopCartData.consegna.tipoPorto =  this.portTypeValue.obj.id;
                this.$root.shopCartData.consegna.tipoPortoDes =  this.portTypeValue.obj.des[this.$root.token.defaultLang];
                this.$root.shopCartData.consegna.tipoPortoFre =  this.portTypeValue.obj.fre;
            }

            //Aggiorno l'ordine con le informazioni su consegna e spedizione
            var vm = this,
                order = vm.reg_orders.find({'id': vm.$root.shopCartData.riferimento})[0],
                now = Date.now(),
                changed = false;
            
            if(order) {
                //confronto campi effettivamente cambiati per evitare update inutili 
                //potrei aver cambiato indirizzo, porto, spedizione, data consegna, etc.
                        
                var scd = vm.$root.shopCartData,
                    o_dbr = scd.spedizione.accorpaSpedizione == vm.$Jed.firstUpperTranslate('yes') || scd.spedizione.accorpaSpedizione == true ? true : false,
                    o_drd = scd.consegna.consegnaRichiesta ? scd.consegna.consegnaRichiesta : null;

                if(order.aid != scd.consegna.idIndirizzo){order.aid = scd.consegna.idIndirizzo; changed = true;}
                if(order.add != scd.consegna.indirizzo){order.add = scd.consegna.indirizzo; changed = true;}
                if(order.loc != scd.consegna.localita){order.loc = scd.consegna.localita; changed = true;}
                if(order.reg != scd.consegna.regione){order.reg = scd.consegna.regione; changed = true;}
                if(order.pro != scd.consegna.provincia){order.pro = scd.consegna.provincia; changed = true;}
                if(order.nat != scd.consegna.nazione){order.nat = scd.consegna.nazione; changed = true;}
                if(order.ufn != scd.consegna.nominativo){order.ufn = scd.consegna.nominativo; changed = true;}
                if(order.dbr != o_dbr){order.dbr = o_dbr; changed = true;}
                if(order.drd != o_drd){order.drd = o_drd; changed = true;}
                if(order.dti != scd.spedizione.tipoSpedizione){order.dti = scd.spedizione.tipoSpedizione; changed = true;}
                if(order.pti != scd.consegna.tipoPorto){order.pti = scd.consegna.tipoPorto; changed = true;}
                if(order.cap != scd.consegna.cap){order.cap = scd.consegna.cap; changed = true;}

                if(changed){
                    order.mdt = now;
                    vm.reg_orders.update(order);
                    console.log('ShopCart2: Aggiornato ordine con id:', order.id, order); 
                    //alla fine delle op sui loki di ordini e righeordine salvo il loki db e chiedo la sync
                    vm.$root.dbRegistry.saveDatabase(function(err) {
                        if (err) {
                            console.log("saveDatabase - error : " + err);
                        } else {
                            if(!vm.$root.preferences.useOffline)vm.$Sync.triggerUpdate() //nuova gestione sync nell'online
                            console.log("ShopCart2: getData - saveDatabase - database aggiornato");
                            eventBus.$emit("cartFilled",vm.$root.shopCartData.prodotti.length);
                        }
                    });
                }              
            }
            
            return this.$root.shopCartData;
        }
    }

}
</script>

<style>

.form-control-cust  {
    height: 28px;
}

.vdp-datepicker input {
    padding-top: 0px;
    padding-bottom: 0px;
    height: 28px;
 }

.v-select .selected-tag {
    margin-top: 0px;
}

.v-select .dropdown-toggle {
    display: flex !important;
    flex-wrap: wrap;
}

.v-select input[type=search], .v-select input[type=search]:focus {
    flex-basis: 20px;
    flex-grow: 1;
    height: 28px;
    padding: 0 20px 0 10px;
    width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/shopcart/ShopCart2.vue?3f7f87ee